<div style="align-items: center">
  <div id="tabCambiarUsuario">
    <div class="col-login">
      <div class="loginInputWrap" [formGroup]="loginForm" style="margin-top: 65px;">
        <div class="tituloInt">{{ 'CAMBIAR_PASSWORD' | translate }}</div>
        <p *ngIf="error" style="color: red">{{ error }}</p>
        <!-- <div class="form-group login">

          <div class="tit-form-group">
            <label for="usuario">{{ 'USUARIO' | translate }}</label>
          </div>
          <input
            formControlName="usuario"
            #usuario
            type="text"
            class="form-control"
            id="usuario"
            category="ALFANUMERICO"
            [ngClass]="{ 'active-form': isSelected(usuario) }"
            (focus)="focusValue($event)"
          />
        </div>
        <div class="form-group login">
          <div class="tit-form-group">
            <label for="contraseniaAnt">{{ 'CONTRASENA' | translate }}</label>
          </div>
          <input
            formControlName="contraseniaAnt"
            #claveAnt
            type="password"
            class="form-control"
            id="contraseniaAnt"
            category="ALFANUMERICO"
            [ngClass]="{ 'active-form': isSelected(claveAnt) }"
            (focus)="focusValue($event)"
          />
        </div> -->
        <div class="form-group login">
          <div class="tit-form-group">
            <label for="contrasena">{{ 'NUEVA_CONTRASENA' | translate }}</label>
          </div>
          <input
            formControlName="contrasena"
            #clave
            category="pago"
            type="password"
            class="form-control"
            id="contrasena"
            category="ALFANUMERICO"
            [ngClass]="{ 'active-form': isSelected(clave) }"
            (focus)="focusValue($event)"
          />
        </div>
        <a
          class="GestionarButton aceptar"
          [ngClass]="{ disabled: checkLoginIsInvalid() }"
          (click)="cambiarPassword()"
          title="Entrar"
        >
          <ng-container>
            {{ 'CAMBIAR' | translate }}
          </ng-container>
        </a>
        <a class=" CancelButton"
    (click)="cancelar()"
    title="Cancelar"
    >
    <ng-container>
      {{ 'CANCELAR' | translate }}
    </ng-container>
    </a>
      </div>
      <ng-template #loading class="DetalleBox__noResultsMessage">
        <div class="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
